<ng-template [ngIf]="rinvioForm">
<div>
	<div class="col-sm-12 coldx">
		<h4>{{title}}</h4>
		<form [formGroup]="rinvioForm" (ngSubmit)="save();">
			<div class="row">
				<div datePickerInput class="col-sm-4" [labelInput]="'Data'" [mandatory]="true" [dataDal]="scadenza.dataScadenza"
					formControlName="dataA" [(ngModel)]="request.dataA" [control]="rinvioForm.controls['dataA']"></div>
				<div oraComboInput formControlName="ora"
					[objectReferenceOra]="oraSet" [objectReferenceMin]="minSet"
					(onReturn)="request.ora = $event"></div>
				<div comboModInput class="col-sm-4" [labelInput]="'Motivo'" [mandatory]="true"
					formControlName="motivo" [objectReference]="request.motivo"
					[control]="rinvioForm.controls['motivo']"
					[ngModel]="request.motivo"
					(onReturn)="request.motivo = $event"
					[optionsCombo] ="motiviOptions"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
	
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
				<p submitButton [disabled]="!rinvioForm.valid"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'"></p>
			
			</div>
		</form>

	</div>
</div>
</ng-template>